import * as React from "react";

import useAuthentication from "./useAuthentication";
import { cancelApplicationAccessRequest, cancelNewApplicationRequest } from "../services/users";

const useCancelApplicationRequest = () => {
	const { getToken, handleLogout } = useAuthentication();
	const [loading, setLoading] = React.useState(false);

	const cancelApplicationRequest = React.useCallback(
		async (appId?: string, type?: string) => {
			try {
				if (appId) {
					setLoading(true);
					const token = await getToken();
					const authHeader = {
						headers: {
							authorization: `Bearer ${token}`,
						},
					};
					if (type === "new") {
						const { data } = await cancelNewApplicationRequest(authHeader, appId);
						return data?.message;
					} else {
						const { data } = await cancelApplicationAccessRequest(authHeader, appId);
						return data?.message;
					}
				}
			} catch (error: any) {
				if (error) {
					if (error?.response?.status == 401) {
						handleLogout();
					}
					return error?.response?.data?.message as string;
				}
			} finally {
				setLoading(false);
			}
		},
		[getToken, handleLogout]
	);

	return { cancelApplicationRequest, loading };
};

export default useCancelApplicationRequest;
